import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import PersonalLoan from "./pages/PersonalLoan";
import HomeLoan from "./pages/HomeLoan";
import LAP from "./pages/LAP";
import GoldLoan from "./pages/GoldLoan";
import About from "./pages/About";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import LendingPartners from "./pages/LendingPartners";

// Component to handle dynamic SEO meta tags
function SEOHandler() {
  const location = useLocation();
  
  useEffect(() => {
    const updateMetaTags = () => {
      const path = location.pathname;
      let title = 'PFIL Finance - Personal Loans, Home Loans & Gold Loans | RBI Registered NBFC Since 1996';
      let description = 'PFIL Finance (POOJA FINSTOCK INTERNATIONAL LIMITED) - RBI registered NBFC offering Personal Loans (16% p.a.), Home Loans, Loan Against Property & Gold Loans since 1996. Quick approval in 24 hours, competitive rates, ₹5 CR+ loans disbursed. Apply online now!';
      let keywords = 'personal loan, home loan, gold loan, loan against property, NBFC, RBI registered, PFIL Finance, POOJA FINSTOCK, instant loan approval, loan in 24 hours, EMI calculator, business loan, quick loan, personal loan 16%, home loan 8.5%, gold loan 13%, Mumbai loans, Pune loans, Ahmedabad loans, loan near me, online loan application, fast loan approval, collateral free loan';
      
      // Set page-specific SEO meta tags
      switch(path) {
        case '/personal-loan':
          title = 'Personal Loan 16% Interest Rate | Fast Approval in 24 Hours | PFIL Finance';
          description = 'Get personal loans starting from 16% p.a. with fast approval in 24 hours. No collateral required, minimal documentation. Apply online at PFIL Finance - RBI registered NBFC since 1996.';
          keywords = 'personal loan 16%, instant personal loan, personal loan no collateral, quick personal loan approval, personal loan 24 hours, PFIL personal loan, RBI registered personal loan, online personal loan India, personal loan minimal documents, unsecured personal loan';
          break;
          
        case '/home-loan':
          title = 'Home Loan from 16% Interest Rate | Dream Home Financing | PFIL Finance';
          description = 'Make your dream home a reality with home loans from 16% p.a. Flexible tenure, competitive rates, quick approval. Apply online at PFIL Finance - RBI registered NBFC since 1996.';
          keywords = 'home loan 16%, dream home loan, home loan India, property loan, home financing, RBI registered home loan, competitive home loan rates, PFIL home loan, online home loan application, home loan quick approval';
          break;
          
        case '/gold-loan':
          title = 'Gold Loan from 13% Interest Rate | 30-Minute Approval | PFIL Finance';
          description = 'Get instant cash against gold ornaments from 13% p.a. 30-minute approval, safe gold storage, flexible repayment. Apply at PFIL Finance - RBI registered NBFC since 1996.';
          keywords = 'gold loan 13%, instant gold loan, gold loan 30 minutes, cash against gold, gold ornament loan, safe gold storage, flexible gold loan repayment, PFIL gold loan, RBI registered gold loan, quick gold loan approval';
          break;
          
        case '/lap':
          title = 'Loan Against Property from 16% Interest Rate | High Value Loans | PFIL Finance';
          description = 'Get substantial loans against property from 16% p.a. High loan amounts, competitive rates, flexible tenure. Apply online at PFIL Finance - RBI registered NBFC since 1996.';
          keywords = 'loan against property 16%, LAP loan, property loan, mortgage loan, high value loans, commercial property loan, residential property loan, PFIL LAP, RBI registered property loan, substantial loan amounts';
          break;
          
        case '/about':
          title = 'About PFIL Finance | RBI Registered NBFC Since 1996 | 10,000+ Happy Customers';
          description = 'Learn about PFIL Finance (POOJA FINSTOCK INTERNATIONAL LIMITED) - RBI registered NBFC since 1996. Serving 10,000+ customers with 99.5% satisfaction. Trusted financial partner for 29+ years.';
          keywords = 'PFIL Finance about, POOJA FINSTOCK INTERNATIONAL LIMITED, RBI registered NBFC, NBFC since 1996, 10000 happy customers, 99.5% customer satisfaction, trusted financial partner, RBI registration B.01.00449';
          break;
          
        case '/lending-partners':
          title = 'About PFIL Finance | RBI Registered NBFC Since 1996 | 10,000+ Happy Customers';
          description = 'Learn about PFIL Finance (POOJA FINSTOCK INTERNATIONAL LIMITED) - RBI registered NBFC since 1996. Serving 10,000+ customers with 99.5% satisfaction. Trusted financial partner for 29+ years.';
          keywords = 'PFIL Finance about, POOJA FINSTOCK INTERNATIONAL LIMITED, RBI registered NBFC, NBFC since 1996, 10000 happy customers, 99.5% customer satisfaction, trusted financial partner, RBI registration B.01.00449';
          break;

        case '/contact':
          title = 'Contact PFIL Finance | Apply for Loans | RBI Registered NBFC | Get in Touch';
          description = 'Contact PFIL Finance for personal loans, home loans, gold loans, and LAP. Visit our offices in Ahmedabad, Pune, or Sinnar. Call 022 69718828 for instant loan assistance.';
          keywords = 'contact PFIL Finance, PFIL Finance offices, loan application, Ahmedabad office, Pune office, Sinnar office, 022 69718828, apply for loan, loan enquiry, PFIL Finance contact details';
          break;
          
        case '/blog':
          title = 'Financial Tips & Loan Guides Blog | PFIL Finance | Expert Financial Advice';
          description = 'Read expert financial advice, loan guides, and tips on personal finance from PFIL Finance. Learn about EMI calculations, CIBIL scores, loan eligibility, and financial planning.';
          keywords = 'PFIL Finance blog, financial tips, loan guides, EMI calculator guide, CIBIL score improvement, personal finance tips, loan eligibility, financial planning India, business loan guide';
          break;
      }
      
      // Update meta tags
      document.title = title;
      
      // Update meta description
      let metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', description);
      }
      
      // Update meta keywords
      let metaKeywords = document.querySelector('meta[name="keywords"]');
      if (metaKeywords) {
        metaKeywords.setAttribute('content', keywords);
      }
      
      // Update Open Graph tags
      let ogTitle = document.querySelector('meta[property="og:title"]');
      if (ogTitle) {
        ogTitle.setAttribute('content', title);
      }
      
      let ogDescription = document.querySelector('meta[property="og:description"]');
      if (ogDescription) {
        ogDescription.setAttribute('content', description);
      }
      
      // Update Twitter Card tags
      let twitterTitle = document.querySelector('meta[property="twitter:title"]');
      if (twitterTitle) {
        twitterTitle.setAttribute('content', title);
      }
      
      let twitterDescription = document.querySelector('meta[property="twitter:description"]');
      if (twitterDescription) {
        twitterDescription.setAttribute('content', description);
      }
    };
    
    updateMetaTags();
  }, [location.pathname]);
  
  return null;
}


function ExternalRedirect({ url }) {
  useEffect(() => {
    window.location.href = url;
  }, [url]);

  return null; 
}


function App() {
  return (
    <div className="App min-h-screen bg-white">
      <BrowserRouter>
        <SEOHandler />
        <ScrollToTop />
        <Navbar />
        <main className="pt-16">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/personal-loan" element={<PersonalLoan />} />
            <Route path="/home-loan" element={<HomeLoan />} />
            <Route path="/lap" element={<LAP />} />
            <Route path="/gold-loan" element={<GoldLoan />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route
              path="/privacy-policy"
              element={<ExternalRedirect url="https://pfilfinance.com/privacy_policy.php" />}
            />
             <Route
              path="/terms-conditions"
              element={<ExternalRedirect url="https://pfilfinance.com/terms_and_condition.php" />}
            />
            <Route path="/lending-partners" element={<LendingPartners />} />
            
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;